export const ROUTE_VALUES = {
  concertStrinigs: [
    "conciertos",
    "konzerte",
    "concerts",
    "concerts",
    "concerti",
    "concertos"
  ],
  festivalStrinigs: [
    "festivales",
    "festivals",
    "festivals",
    "festivals",
    "festivais",
    "festival"
  ],
  artistStrinigs: ["artistas", "künstler", "artists", "artistes", "artisti"],
  venueStrinigs: [
    "recintos",
    "veranstaltungsorte",
    "venue",
    "lieux",
    "sedi",
    "locais"
  ],
  pageStrinigs: [
    "festivales",
    "festivals",
    "festivals",
    "festivals",
    "festivais",
    "festival"
  ]
};



// export const VALID_REGIONS = [
//   "es",
//   "en",
//   "de",
//   "gb",
//   "fr",
//   "it",
//   "pt",
//   "ch",
//   "nl",
//   "ie",
//   "at",
//   "be",
//   "mx",
//   "co",
//   "ar",
//   "cl",
//   "br",
//   "us",
//   "ca",
//   "au",
//   "se",
//   "pe",
//   "es-es",
//   "es-us",
//   "es-mx",
//   "es-co",
//   "es-ar",
//   "es-cl",
//   "es-br",
//   "es-pe",
//   "de-de",
//   "de-at",
//   "de-ch",
//   "en-gb",
//   "en-ch",
//   "en-nl",
//   "en-ie",
//   "en-at",
//   "en-be",
//   "en-us",
//   "en-ca",
//   "en-au",
//   "en-se",
//   "en-es",
//   "fr-fr",
//   "fr-ca",
//   "fr-be",
//   "it-it",
//   "pt-pt"
// ];
// export const ESPECIAL_REGIONS = { "en-es": "en" };
// export const LG = {
//   spanish: [
//     "es",
//     "mx",
//     "co",
//     "ar",
//     "cl",
//     "pe",
//     "es-es",
//     "es-us",
//     "es-mx",
//     "es-co",
//     "es-ar",
//     "es-cl",
//     "es-br",
//     "es-en",
//     "es-pe"
//   ],
//   german: ["de", "de-de", "de-at", "de-ch"],
//   english: [
//     "gb",
//     "ch",
//     "en",
//     "nl",
//     "ie",
//     "at",
//     "be",
//     "us",
//     "ca",
//     "au",
//     "se",
//     "en-gb",
//     "en-ch",
//     "en-nl",
//     "en-ie",
//     "en-at",
//     "en-be",
//     "en-us",
//     "en-ca",
//     "en-au",
//     "en-se",
//     "en-es"
//   ],
//   french: ["fr", "fr-fr", "fr-ca", "fr-be"],
//   italian: ["it", "it-it"],
//   portuguese: ["pt", "br", "pt-pt"]
// };
// export const DEFAULT_LANGUAGES = {
//   es: "es",
//   de: "de",
//   gb: "en",
//   fr: "fr",
//   it: "it",
//   pt: "pt",
//   ch: "de",
//   nl: "en",
//   ie: "en",
//   at: "de",
//   be: "fr",
//   mx: "es",
//   co: "es",
//   ar: "es",
//   cl: "es",
//   pe: "es",
//   br: "pt",
//   us: "en",
//   ca: "en",
//   au: "en",
//   se: "en",
//   en: "en"
// };

// export const REGIONS_NAMES = {
//   es: "España",
//   de: "Deutschland",
//   gb: "Great Britain",
//   fr: "France",
//   it: "Italia",
//   pt: "Portugal",
//   ch: "Die Schweiz",
//   nl: "Netherlands",
//   ie: "Ireland",
//   at: "Österreich",
//   be: "Belgique",
//   mx: "México",
//   co: "Colombia",
//   ar: "Argentina",
//   cl: "Chile",
//   br: "Brasil",
//   us: "United States",
//   ca: "Canada",
//   au: "Australia",
//   se: "Sweden"
// };

// export const VALID_LANGUAGES = ["es", "de", "en", "fr", "it", "pt"];

// export const COUNTRY_ORDERS = {
//   us: [2, 1, 3]
// };

// export const DAYS_TRADUCTIONS = [
//   "general.calendar.days.monday",
//   "general.calendar.days.tuesday",
//   "general.calendar.days.wednesday",
//   "general.calendar.days.thursday",
//   "general.calendar.days.friday",
//   "general.calendar.days.saturday",
//   "general.calendar.days.sunday"
// ];

// export const MONTH_TRADUCTIONS = [
//   "general.calendar.months.january",
//   "general.calendar.months.february",
//   "general.calendar.months.march",
//   "general.calendar.months.april",
//   "general.calendar.months.may",
//   "general.calendar.months.june",
//   "general.calendar.months.july",
//   "general.calendar.months.august",
//   "general.calendar.months.september",
//   "general.calendar.months.octuber",
//   "general.calendar.months.november",
//   "general.calendar.months.december"
// ];

// export const BREAKPOINTS = {
//   basicCards: {
//     0: {
//       itemsToShow: 1,
//       snapAlign: "start"
//     },
//     700: {
//       itemsToShow: 1.5,
//       snapAlign: "start"
//     },
//     900: {
//       itemsToShow: 2.1,
//       snapAlign: "start"
//     },
//     1200: {
//       itemsToShow: 2.45,
//       snapAlign: "start"
//     },
//     1280: {
//       itemsToShow: 1.6,
//       snapAlign: "start"
//     },
//     1600: {
//       itemsToShow: 2.6,
//       snapAlign: "start"
//     }
//   },
//   eventCards: {
//     0: {
//       itemsToShow: 1,
//       snapAlign: "start"
//     },
//     700: {
//       itemsToShow: 1.2,
//       snapAlign: "start"
//     },
//     900: {
//       itemsToShow: 2.8,
//       snapAlign: "start"
//     },
//     1200: {
//       itemsToShow: 3.4,
//       snapAlign: "start"
//     },
//     1280: {
//       itemsToShow: 2.1,
//       snapAlign: "start"
//     },
//     1600: {
//       itemsToShow: 3.5,
//       snapAlign: "start"
//     }
//   },
//   images: {
//     0: {
//       itemsToShow: 1,
//       snapAlign: "start"
//     },
//     700: {
//       itemsToShow: 1.2,
//       snapAlign: "start"
//     },
//     900: {
//       itemsToShow: 1.8,
//       snapAlign: "start"
//     },
//     1200: {
//       itemsToShow: 2.3,
//       snapAlign: "start"
//     },
//     1280: {
//       itemsToShow: 1.4,
//       snapAlign: "start"
//     },
//     1600: {
//       itemsToShow: 2.2,
//       snapAlign: "start"
//     }
//   }
// };

// export const SEATSIOCONFIG = {
//   cursorTooltip: {
//     showActionHint: true,
//     showCategory: true,
//     showLabel: true,
//     showPricing: true,
//     showUnavailableNotice: true,
//     stylizedLabel: true
//   },
//   holdOnSelect: true,
//   holdOnSelectForGAs: true,
//   mobileTooltip: {
//     showCategory: true,
//     showPricing: true
//   },
//   colorScheme: "dark",
//   colors: {
//     "theme-cursor-tooltip-background-color": "#252525",
//     "theme-color-selected": "#2effec"
//   },
//   showRowLines: true,
//   objectWithoutPricingSelectable: false,
//   objectWithoutCategorySelectable: false,
//   loading: `<div class="loader-inner line-scale-party mAuto">
//     <div></div> <div></div> <div></div> <div></div></div>`
// };
